var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPepperHot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0923 4.80513C12.5638 3.96182 12.5289 2.88978 11.9681 2.1003C11.8024 1.86233 11.4779 1.80301 11.2386 1.96982C11.002 2.13633 10.9433 2.46531 11.1091 2.70393C11.4257 3.16008 11.4415 3.75181 11.1991 4.23696C10.8201 4.05587 10.4004 3.946 9.96094 3.946C9.16487 3.946 8.44636 4.24988 7.89023 4.73526L9.60938 5.49288V7.4814H11.5992L12.336 9.20033C12.8218 8.64376 13.125 7.92525 13.125 7.11007C13.125 6.20699 12.7229 5.38521 12.0923 4.80513ZM8.90625 8.18453V5.9565L7.7428 5.45794C6.62549 7.15841 6.01685 10.6455 3.10547 10.6455C2.42717 10.6455 1.875 11.197 1.875 11.8759C1.875 12.5549 2.42717 13.1064 3.10547 13.1064C7.06714 13.1064 10.1389 11.1669 11.6594 9.40401L11.1365 8.18453H8.90625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepperHot);
export default __webpack_public_path__ + "static/media/pepper_hot.ed6d548742d1e61ff90a66b1b464d249.svg";
export { ForwardRef as ReactComponent };